// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7b6423a6","952":"615c44f0"}[chunkId] + ".chunk.js";
};